import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DataList } from "@/common/DataList";
import type { GeneralInfoTabFormValues } from "@/entities/general-info-tab-content/model";
import { LinkField } from "./LinkField";

type Props = {
  personId: string;
  isEditMode: boolean;
  handleEditMode: () => void;
  onSubmit: (data: GeneralInfoTabFormValues) => void;
  disabled?: boolean;
};

export const LinksList = ({ personId, isEditMode, handleEditMode, onSubmit, disabled }: Props) => {
  const { t } = useTranslation();

  const { control, getValues, trigger } = useFormContext<GeneralInfoTabFormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "websites",
  });

  const onBlur = async () => {
    const isValid = await trigger("websites");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  const onChange = () => {
    trigger("websites");
  };

  const addHandler = () => {
    if (!isEditMode) {
      handleEditMode();
    }

    setTimeout(() => {
      append({
        websiteType: { name: "" },
        websiteAddress: "",
        id: undefined,
        personId,
      });
    }, 0);
  };

  const removeHandler = async (index: number) => {
    remove(index);

    const isValid = await trigger("websites");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  return (
    <DataList
      data={fields.map((item) => ({
        id: item?.id ?? "",
        label: item?.websiteType?.name ?? "",
        value: item?.websiteAddress ?? "",
      }))}
      onAddClick={addHandler}
      onTrashClick={removeHandler}
      isEdit={isEditMode}
      title={t("contactsPage.generalInfo.websites")}
      editNode={(index) => <LinkField index={index} onBlur={onBlur} onChange={onChange} />}
      disabled={disabled}
    />
  );
};
